import React, { useCallback, useEffect, useState } from "react";
import { wordpressRoot } from "../../configFile";
import './Actualites.css'
import dateToReadableDate from "../../utils";
import { Link } from "react-router-dom";

export default function Actualites() {

  const [articles, setArticles] = useState([])

  const fetchArticles = useCallback(async () => {
    const response = await fetch(wordpressRoot + 'wp-json/wp/v2/posts?_embed');
    if (!response.ok) return
    
    const data = await response.json();
    setArticles(data)
    console.log(data)
  }, [])
  
  useEffect(() => {
    fetchArticles()
  }, [fetchArticles])

  return (
    <div className='articles'>
        <h1>Les actualités</h1>
      {
        articles.map((article) => {
          const date = dateToReadableDate(article.date)
          return (
            <Link to={article.link} key={article.id} className="article">
              <div className="article-title">
                <h3> {article.title.rendered} </h3>
                {
                  date !== "" && date &&
                  <span> posté le {date} </span>
                }
              </div>
              <div dangerouslySetInnerHTML={{ __html: article.excerpt.rendered }} />
              <div className="divider"> </div>
            </Link>
          )
        })
      }
    </div>
  )
}
